import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DEFAULT_SETTINGS = {
  term_label: "Term 4",
  enrol_headline: "Secure your spot for Term 4. No lock-in, no pressure. Just expert tutoring that gets results.",
  spots_note: "Trusted by 70+ Melbourne families — no lock-in, no pressure.",
};

let cached = null;

export function useSiteSettings() {
  const [settings, setSettings] = useState(cached || DEFAULT_SETTINGS);

  useEffect(() => {
    if (cached) return;
    let alive = true;
    axios
      .get(`${API}/settings`)
      .then((res) => {
        cached = { ...DEFAULT_SETTINGS, ...res.data };
        if (alive) setSettings(cached);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  return settings;
}

export function clearSettingsCache() {
  cached = null;
}
